<template>
  <f7-page name="lms-metar" @page:init="onPageInit">
    <f7-navbar>
      <f7-nav-left>
        <f7-link icon-ios="f7:menu" icon-aurora="f7:menu" icon-md="material:menu" panel-open="left"></f7-link>
      </f7-nav-left>
      <f7-nav-title sliding>METAR</f7-nav-title>
      <f7-nav-right>
        <f7-link icon-ios="f7:arrow_2_circlepath" icon-aurora="f7:arrow_2_circlepath" icon-md="material:autorenew" @click="pageReload($event,false) " href="#" ></f7-link>
        <f7-link icon-ios="f7:arrow_left" icon-aurora="f7:arrow_left" icon-md="material:arrow_back" @click="$f7router.back()" href="#" ></f7-link>
      </f7-nav-right>
    </f7-navbar>
    <template v-if="isDataLoaded">

      <f7-toolbar tabbar bottom>
        <f7-link tab-link="#metar-shmu" tab-link-active>METAR SHMÚ</f7-link>
        <f7-link tab-link="#metar-mil">METAR MIL</f7-link>
      </f7-toolbar>

      <f7-tabs>
        <f7-tab id="metar-shmu" tab-active>

          <div class="no-padding">
            <f7-list class="no-margin">
              <f7-list-item title="Vyberte čas:" smart-select :smart-select-params="{openIn: 'popover', searchbar: false, popupCloseLinkText:'Zavrieť', closeOnSelect:true}">
                <select v-model="selectedDateSHMU">
                  <option v-for="date in listOfDatesSHMU" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }} UTC</option>
                </select>
              </f7-list-item>
            </f7-list>
          </div>

          <f7-block class="no-padding no-margin-vertical margin-horizontal-half">
            <strong>Správy METAR z profesionálnych meteorologických staníc SHMÚ</strong>

          <div class="padding-horizontal-half pre-ov-wpr">
            <template v-if="selectedContentSHMU">
              <div class="pre-wrapper">
                <pre v-for="(content, index) in selectedContentSHMU" :key="index" v-html="removeHeaderFromContnet(content.body, content.header)"></pre>
              </div>
            </template>

          </div>

          </f7-block>



        </f7-tab>
        <f7-tab id="metar-mil">

          <div class="no-padding">
            <f7-list class="no-margin">
              <f7-list-item title="Vyberte čas:" smart-select :smart-select-params="{openIn: 'popover', searchbar: false, popupCloseLinkText:'Zavrieť', closeOnSelect:true}">
                <select v-model="selectedDateMIL">
                  <option v-for="date in listOfDatesMIL" :value="date">{{ date | moment("DD.MM.YYYY HH:mm") }} UTC</option>
                </select>
              </f7-list-item>
            </f7-list>
          </div>

          <f7-block class="no-padding no-margin-vertical margin-horizontal-half">
            <strong>Správy METAR z vojenských meteorologických staníc (MIL)</strong>
            (SHMÚ nezodpovedá za ich obsah)

            <div class="padding-horizontal-half pre-ov-wpr">
              <template v-if="selectedContentMIL">
                <div class="pre-wrapper">
                  <pre v-for="(content, index) in selectedContentMIL" :key="index" v-html="removeHeaderFromContnet(content.body, content.header)"></pre>
                </div>
              </template>

            </div>

          </f7-block>

        </f7-tab>
      </f7-tabs>

    </template>
  </f7-page>
</template>
<script>
import Axios from "axios";
import SHMUconf from "../js/SHMUconf";


export default {
  data: function () {
    return {
      isDataLoaded: false,
      latestDataSHMU: [],
      listOfDatesSHMU: [],
      latestDataMIL: [],
      listOfDatesMIL: [],
      selectedDateMIL: null,
      selectedDateSHMU: null,
      lastUpdated: 0,
      tCheckInterval: null,
    };
  },
  filters: {
    capitalize: function(s) {
      return s.charAt(0).toUpperCase() + s.slice(1)
    }
  },
  mounted() {
    const self = this;
    // otvorime hlavne menu
    this.$f7.accordion.close('.shmu-i-pocasie');
    this.$f7.accordion.open('.shmu-i-pocasie');

  },
  destroy() {
    clearInterval(this.tCheckInterval);
  },
  watch: {
    selectedDateSHMU(v) {

      /*
      let currentIndex = this.listOfDatesSHMU.findIndex(item => item === v);
      let minIndex = 0;
      let maxIndex = this.listOfDatesSHMU.length - 1;

      if (currentIndex <= minIndex) {
        this.prevDisabled = true;
      } else {
        this.prevDisabled = false;
      }

      if (currentIndex >= maxIndex) {
        this.nextDisabled = true;
      } else {
        this.nextDisabled = false;
      }

       */

    }
  },
  computed: {
    selectedDateIndexSHMU() {
      const sDate = this.selectedDateSHMU;
      return this.listOfDatesSHMU.findIndex(item => item === sDate);

    },
    selectedContentSHMU() {
      const sDate = this.selectedDateSHMU;
      if (sDate) {
        let r = this.latestDataSHMU.filter(item => item.dt === sDate);
        if (r.length) {
          r.sort((a, b) => (a.header > b.header) ? 1 : ((b.header > a.header) ? -1 : 0))
          return r;
        }
      }
    },
    selectedDateIndexMIL() {
      const sDate = this.selectedDateMIL;
      return this.listOfDatesMIL.findIndex(item => item === sDate);

    },
    selectedContentMIL() {
      const sDate = this.selectedDateMIL;
      if (sDate) {
        let r = this.latestDataMIL.filter(item => item.dt === sDate);
        if (r.length) {
          r.sort((a, b) => (a.header > b.header) ? 1 : ((b.header > a.header) ? -1 : 0))
          return r;
        }
      }
    },
  },

  methods: {
    onPageInit() {
      this.pageReload(null, true);
    },
    pageReload(event, isInit) {
      const self = this;

      if (isInit || (this.$moment().unix() - this.lastUpdated) > 60) { // ak posledne stiahnutie bolo menej ako 1 min, tak nedovolime refresh

        self.$f7.dialog.preloader('Načítavam...');

        Axios.get(SHMUconf.API_BASE_URL + 'lms/getmetar', {
          crossDomain: true,
          cache: false,
        })
            .then((response) => {
              if (!response.data.error) {

                self.latestDataSHMU = response.data['data_shmu'];
                self.latestDataMIL = response.data['data_mil'];

                let allDatesSHMU = [... new Set(self.latestDataSHMU.map((item) => item.dt))]; // unique
                self.listOfDatesSHMU =  allDatesSHMU.sort().reverse();
                if (self.listOfDatesSHMU.length) {
                  self.selectedDateSHMU = self.listOfDatesSHMU[0];
                }

                let allDatesMIL = [... new Set(self.latestDataMIL.map((item) => item.dt))]; // unique
                self.listOfDatesMIL =  allDatesMIL.sort().reverse();
                if (self.listOfDatesMIL.length) {
                  self.selectedDateMIL = self.listOfDatesMIL[0];
                }

                self.isDataLoaded = true;


                self.lastUpdated = self.$moment().unix();


              } else {
                self.$f7.dialog.alert('Nepodarilo sa načítať METAR správy', 'Nastala chyba');
              }

              self.$f7.dialog.close();
            }).catch((error) => {
          self.$f7.dialog.close();
          self.$f7.dialog.alert('Nepodarilo sa nadviazať spojenie so serverom SHMÚ', 'Nastala chyba spojenia');
        });
      }


    },
    removeHeaderFromContnet(content, header) {
      if (this.show_header) {
        return content;
      }

      return content.replace(header, '').replace('\r\n', '');
    },
    checkLastUpdated() {
      if ((this.$moment().unix() - this.lastUpdated) > 5*60) { // ak posledne stiahnutie bolo pred vic ako 5 min, tak refresh
        this.pageReload(null, false);
      }
    }

  }

};
</script>

<style lang="scss">

.pre-wrapper pre {
  font-size: 12px;
}

.pre-ov-wpr {
  overflow: auto;
  height: calc(100vh - var(--f7-navbar-height) - var(--f7-safe-area-top) - var(--f7-toolbar-height) - var(--f7-safe-area-bottom) - 100px);
}

</style>
